module.exports = __webpack_public_path__ + "48ec448c29941e015fb57077a0ff5489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile22.png
// module id = 1883
// module chunks = 0